import { createStyles, Theme } from '@zn-material-ui'
export default (theme: Theme) =>
  createStyles({
    switchLanguage: {
      position: 'relative',
    },
    box: {
      fontFamily: 'PingFangSC-Regular',
      fontSize: '12px',
      color: '#333333',
      lineHeight: '17px',
      width: '63px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      cursor: 'pointer',
    },
    imgIcon: {
      width: '8px',
      height: '5px',
      marginLeft: '5px',
      display: 'inline-block',
    },
    switchBox: {
      width: '110px',
      boxSizing: 'border-box',
      padding: '13px 20px 13px 29px',
      backgroundColor: '#FFFFFF',
      boxShadow: '0 0 8px 0 rgba(0,0,0,0.30)',
      fontSize: '13px',
      lineHeight: '32px',
      position: 'absolute',
      top: '32px',
      color: '#7F7F7F',
      cursor: 'pointer',
    },
    selected: {
      color: '#FA534A',
      fontFamily: 'PingFangSC-Regular',
      fontWeight: 600,
    },
  })
